import React, { useState, useEffect } from 'react';
import { supabase } from '../Servicios/supabaseClient';
import { useAuth } from '../Context/AuthContext';
import Swal from 'sweetalert2';

export default function TeamModal({ onClose }) {
    const { user } = useAuth();
    const [emails, setEmails] = useState([]);
    const [loading, setLoading] = useState(true);

    // Formulario
    const [newEmail, setNewEmail] = useState('');
    const [newAlias, setNewAlias] = useState('');
    const [adding, setAdding] = useState(false);

    // --- ESTADO NUEVO PARA EDICIÓN ---
    const [editingId, setEditingId] = useState(null);

    // --- 1. CARGAR LISTA ---
    const fetchEmails = async () => {
        try {
            setLoading(true);
            const { data, error } = await supabase
                .from('authorized_emails')
                .select('*')
                .eq('user_id', user.id)
                .order('created_at', { ascending: false });

            if (error) throw error;
            setEmails(data);
        } catch (error) {
            console.error("Error cargando emails:", error.message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (user) fetchEmails();
    }, [user]);

    // --- FUNCIÓN PARA CARGAR DATOS EN EL FORM (Al tocar Editar) ---
    const handleEditClick = (item) => {
        setNewEmail(item.email);
        setNewAlias(item.alias || '');
        setEditingId(item.id);
    };

    // --- FUNCIÓN PARA CANCELAR EDICIÓN ---
    const handleCancel = () => {
        setNewEmail('');
        setNewAlias('');
        setEditingId(null);
    };

    // --- 2. AGREGAR O EDITAR EMAIL ---
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!newEmail.includes('@')) {
            Swal.fire({ icon: 'error', title: 'Error', text: 'Email inválido' });
            return;
        }

        setAdding(true);
        try {
            if (editingId) {
                // --- MODO ACTUALIZAR (UPDATE) ---
                const { error } = await supabase
                    .from('authorized_emails')
                    .update({
                        email: newEmail.toLowerCase().trim(),
                        alias: newAlias
                    })
                    .eq('id', editingId);

                if (error) throw error;

                Swal.fire({
                    icon: 'success',
                    title: 'Miembro actualizado',
                    text: 'Los datos del miembro han sido actualizados.',
                    timer: 2000,
                    showConfirmButton: false
                });

            } else {
                // --- MODO CREAR (INSERT) ---
                const { error } = await supabase
                    .from('authorized_emails')
                    .insert([{
                        user_id: user.id,
                        email: newEmail.toLowerCase().trim(),
                        alias: newAlias
                    }]);

                if (error) throw error;

                Swal.fire({
                    icon: 'success',
                    title: 'Miembro agregado',
                    text: 'El miembro del equipo ha sido agregado correctamente.',
                    timer: 2000,
                    showConfirmButton: false
                });
            }

            // Limpiar y recargar
            handleCancel();
            fetchEmails();

        } catch (error) {
            if (error.code === '23505') { // Código de error de duplicados en Postgres
                Swal.fire({ icon: 'warning', title: 'Duplicado', text: 'Este correo ya está autorizado.' });
            } else {
                Swal.fire({ icon: 'error', title: 'Error', text: 'Error: ' + error.message });
            }
        } finally {
            setAdding(false);
        }
    };

    // --- 3. BORRAR EMAIL ---
    const handleDelete = async (id) => {
        const result = await Swal.fire({
            title: '¿Estás seguro?',
            text: "¿Quitar autorización a este correo?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Sí, quitar',
            cancelButtonText: 'Cancelar'
        });

        if (!result.isConfirmed) return;

        try {
            const { error } = await supabase
                .from('authorized_emails')
                .delete()
                .eq('id', id);

            if (error) throw error;
            setEmails(emails.filter(e => e.id !== id));

            // Si estábamos editando justo ese, cancelamos
            if (editingId === id) {
                handleCancel();
            }

            Swal.fire(
                'Eliminado',
                'El miembro ha sido quitado del equipo.',
                'success'
            );
        } catch (error) {
            Swal.fire({ icon: 'error', title: 'Error', text: 'Error al borrar: ' + error.message });
        }
    };

    return (
        <div className="modalOverlay">
            <div className="modalContent" style={{ maxWidth: '600px', width: '95%' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
                    <h3 style={{ margin: 0, color: 'white' }}>Gestionar Team</h3>
                    <button onClick={onClose} className="btnSecondary" style={{ padding: '4px 8px' }}>✕</button>
                </div>

                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '2rem' }}>
                    {/* Columna Izquierda: Lista de Emails */}
                    <div>
                        <h4 style={{ color: '#8896a7', marginBottom: '1rem', fontSize: '0.9rem', textTransform: 'uppercase' }}>Miembros del Team</h4>

                        {loading ? (
                            <div style={{ color: '#888', fontStyle: 'italic' }}>Cargando...</div>
                        ) : emails.length === 0 ? (
                            <div style={{ color: '#888', fontStyle: 'italic' }}>No hay miembros en el equipo.</div>
                        ) : (
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', maxHeight: '300px', overflowY: 'auto' }}>
                                {emails.map(item => (
                                    <div key={item.id} style={{
                                        background: 'rgba(255,255,255,0.05)',
                                        padding: '10px',
                                        borderRadius: '8px',
                                        border: '1px solid #333',
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center'
                                    }}>
                                        <div>
                                            <div style={{ fontWeight: 'bold', color: '#fff' }}>{item.alias || 'Sin nombre'}</div>
                                            <div style={{ fontSize: '0.8rem', color: '#aaa' }}>{item.email}</div>
                                        </div>
                                        <div style={{ display: 'flex', gap: '8px' }}>
                                            <button
                                                onClick={() => handleEditClick(item)}
                                                style={{
                                                    background: 'transparent',
                                                    border: 'none',
                                                    color: '#4a90e2',
                                                    cursor: 'pointer',
                                                    fontSize: '1.2rem'
                                                }}
                                                title="Editar"
                                            >
                                                ✎
                                            </button>
                                            <button
                                                onClick={() => handleDelete(item.id)}
                                                style={{
                                                    background: 'transparent',
                                                    border: 'none',
                                                    color: '#ff5656',
                                                    cursor: 'pointer',
                                                    fontSize: '1.2rem'
                                                }}
                                                title="Quitar"
                                            >
                                                ×
                                            </button>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>

                    {/* Columna Derecha: Formulario de Alta/Edición */}
                    <div style={{ borderLeft: '1px solid #333', paddingLeft: '2rem' }}>
                        <h4 style={{ color: '#8896a7', marginBottom: '1rem', fontSize: '0.9rem', textTransform: 'uppercase' }}>
                            {editingId ? 'Editar Miembro' : 'Agregar Miembro'}
                        </h4>

                        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                            <div>
                                <label className="inputLabel">Nombre / Alias</label>
                                <input
                                    type="text"
                                    className="inputField"
                                    placeholder="Ej: Juan Perez"
                                    value={newAlias}
                                    onChange={e => setNewAlias(e.target.value)}
                                    required
                                />
                            </div>

                            <div>
                                <label className="inputLabel">Correo Electrónico</label>
                                <input
                                    type="email"
                                    className="inputField"
                                    placeholder="juan@empresa.com"
                                    value={newEmail}
                                    onChange={e => setNewEmail(e.target.value)}
                                    required
                                />
                            </div>

                            <div style={{ display: 'flex', gap: '10px', marginTop: '1rem' }}>
                                <button type="submit" className="btnPrimary" disabled={adding} style={{ flex: 1 }}>
                                    {adding ? 'Guardando...' : (editingId ? 'Actualizar Miembro' : 'Agregar al Team')}
                                </button>
                                {editingId && (
                                    <button
                                        type="button"
                                        className="btnSecondary"
                                        onClick={handleCancel}
                                        disabled={adding}
                                    >
                                        Cancelar
                                    </button>
                                )}
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}
